import { UPDATE_PRODUCT_CARD, UPDATE_MODAL_VISIBILITY } from './types';

export const updateProductModal = (payload) => (dispatch) => {
  return dispatch({ type: UPDATE_PRODUCT_CARD, payload });
};

export const updateModalVisibility = (payload) => (dispatch) => {
  return dispatch({ type: UPDATE_MODAL_VISIBILITY, payload });
};
